/**
 * @name: directives.js
 * @description: 自定义指令
 * @author: 于海威
 * @create: 2020/08/10 08:39:28
 * @update: 2020/08/10 08:39:28
 */
import Vue from 'vue';

Vue.directive('validate', {
  inserted: function (el, validateStr) {
    // validateStr = 'required|email|phone|min(1)|max(10)|minLength(1)|maxLength(10)|regex(/^1[^012]\\d{9}$/)'
    const validateRule = validateStr.value.split('|');
    const validateInput = ['input', 'select', 'textarea'];
    const tagName = el.tagName.toLowerCase();
    const index = validateInput.indexOf(tagName);
    let validateDom = el;
    if (index < 0) {
      validateDom = el.querySelector('input') || el.querySelector('textarea') || el.querySelector('select');
    }

    function tip(msg) {
      let className = validateDom.className;
      const {
        top,
        width,
        left,
        height
      } = validateDom.getBoundingClientRect();
      let tipDom = validateDom.parentNode.querySelector('.validate-tip');
      if (tipDom) {
        tipDom.innerText = msg;
      } else {
        tipDom = document.createElement('DIV');
        tipDom.style.position = 'absolute';
        tipDom.style.left = `${left + width + 10}px`;
        tipDom.style.top = `0px`;
        tipDom.style.lineHeight = `${height}px`;
        tipDom.style.color = 'red';
        tipDom.style.width = '200px';
        tipDom.className = 'validate-tip';
        tipDom.innerText = msg;
        validateDom.parentNode.appendChild(tipDom);
      }

      if (/validate-err$/g.test(className)) {} else {
        validateDom.className = `${className} validate-err`;
      }
    }

    function removeTip() {
      let className = validateDom.className;
      if (/validate-err$/g.test(className)) {
        validateDom.className = className.replace(/validate-err/g, '');
      }
      let tipDom = validateDom.parentNode.querySelector('.validate-tip');
      if (tipDom) {
        validateDom.parentNode.removeChild(tipDom);
      }
    }

    function required() {
      let domValue = validateDom.value;
      if (domValue == '' || domValue == null) {
        tip('内容不能为空');
        return false;
      }
      return true;
    }

    function email() {
      let domValue = validateDom.value;
      if (!/^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/.test(domValue)) {
        tip('请输入正确的邮箱地址');
        return false;
      }
      return true;
    }

    function phone() {
      let domValue = validateDom.value;
      if (!/^1[^012]\d{9}$/.test(domValue)) {
        tip('请输入正确的手机号码');
        return false;
      }
      return true;
    }

    function min(n) {
      let domValue = validateDom.value;
      if (domValue < n) {
        tip(`最小值不能小于${n}`);
        return false;
      }
      return true;
    }

    function max(n) {
      let domValue = validateDom.value;
      if (domValue > n) {
        tip(`最大值不能大于${n}`);
        return false;
      }
      return true;
    }

    function minLength(n) {
      let domValue = validateDom.value;
      if (domValue.toString().length < n) {
        tip(`最小长度不能小于${n}`);
        return false;
      }
      return true;
    }

    function maxLength(n) {
      let domValue = validateDom.value;
      if (domValue.toString().length > n) {
        tip(`最大长度不能大于${n}`);
        return false;
      }
      return true;
    }

    function regex(reg) {
      let domValue = validateDom.value;
      if (!reg.test(domValue)) {
        tip('请输入正确的格式');
        return false;
      }
      return true;
    }

    function password() {
      let domValue = validateDom.value;
      if (!/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()_+.])[a-zA-Z\d!@#$%^&*()_+.]{10,16}$/.test(domValue)) {
        tip('请输入正确的密码');
        return false;
      }
      return true;
    }

    function checkedThis() {
      const requiredReg = /^required$/;
      const emailReg = /^email$/;
      const phoneReg = /^phone$/;
      const minReg = /^min\(\d+\)$/;
      const maxReg = /^max\(\d+\)$/;
      const minLengthReg = /^minLength\(\d+\)$/;
      const maxLengthReg = /^maxLength\(\d+\)$/;
      const regReg = /^regex\(\/.+\/\)$/;
      const passwordReg = /^password$/;
      for (let i = 0; i < validateRule.length; i++) {
        if (requiredReg.test(validateRule[i])) {
          if (!required()) {
            break;
          } else {
            removeTip();
          }
        }
        if (emailReg.test(validateRule[i])) {
          if (!email()) {
            break;
          } else {
            removeTip();
          }
        }
        if (phoneReg.test(validateRule[i])) {
          if (!phone()) {
            break;
          } else {
            removeTip();
          }
        }
        if (minReg.test(validateRule[i])) {
          if (!eval(validateRule[i])) {
            break;
          } else {
            removeTip();
          }
        }
        if (maxReg.test(validateRule[i])) {
          if (!eval(validateRule[i])) {
            break;
          } else {
            removeTip();
          }
        }
        if (minLengthReg.test(validateRule[i])) {
          if (!eval(validateRule[i])) {
            break;
          } else {
            removeTip();
          }
        }
        if (maxLengthReg.test(validateRule[i])) {
          if (!eval(validateRule[i])) {
            break;
          } else {
            removeTip();
          }
        }
        if (regReg.test(validateRule[i])) {
          if (!eval(validateRule[i])) {
            break;
          } else {
            removeTip();
          }
        }
        if (passwordReg.test(validateRule[i])) {
          if (!password()) {
            break;
          } else {
            removeTip();
          }
        }
      }
    }
    if (validateDom) {
      validateDom.addEventListener('blur', () => {
        checkedThis();
      });
    }
  }
});
